export const constants = {
    /**
     * HostGator_settings
     * @property API_EXPRESS_API_KEY       - 
     */
    HostGator_settings: {
        "API_EXPRESS_API_KEY": "ff7a26f7-4790-43e8-bc10-1d2e9a6be722"
    },
    /**
     * Settings
     */
    Settings: {},
    /**
     * HotelApp_settings
     * @property database_id       - 
     */
    HotelApp_settings: {
        "database_id": "5f172ba90f0d3171fef7f683"
    }
};
export const routes = {
    "Login_": "login_",
    "Home": "home",
    "Restaurantes": "restaurantes",
    "Servicios": "servicios/:idPDV",
    "Platos": "platos/:idPDV/:idServicio/:idTipoPlato",
    "Spa_Tipo_Tratamiento": "spa_tipo_tratamiento/:id_Tipo_Spa",
    "Reservas_Resto": "reservas_resto",
    "Resort": "resort",
    "Resort_Indoor": "resort_indoor",
    "Resort_Outdoor": "resort_outdoor",
    "Reservas_Spa": "reservas_spa",
    "Reservas_Outdoor": "reservas_outdoor",
    "Spa": "spa",
    "Configuracion": "config",
    "Pedidos": "pedidos/:idPDV",
    "Spa_Programas": "spa_programas",
    "Spa_Especiales": "spa_especiales",
    "Spa_Memorables": "spa_memorables",
    "Mis_Reservas": "mis_reservas",
    "Tipo_Plato_Room": "tipo_plato_room",
    "Resort_Piscina": "resort_piscina",
    "Resort_Marina": "resort_marina",
    "Platos_Room_Desayuno": "platos_room_desayuno",
    "Platos_Room_Entradas": "platos_room_entradas",
    "Platos_Room_Principales": "platos_room_principales",
    "Platos_Room_Postres": "platos_room_postres",
    "Platos_Room_Bebidas": "platos_room_bebidas",
    "Reservas_Canchas": "reservas_canchas",
    "Platos_Room_Viandas": "platos_room_viandas",
    "Platos_Room_Infantil": "platos_room_infantil",
    "Platos_Room_Spa": "platos_room_spa",
    "Platos_Room_Celiacos": "platos_room_celiacos",
    "Tipo_Bebidas": "tipo_bebidas",
    "Novedades": "novedades",
    "Golf": "golf",
    "Platos_Room_Minibares": "platos_room_minibares",
    "Reservas_Piscina": "reservas_piscina",
    "Reservas_Indoor": "reservas_indoor",
    "Reservas_Desayuno": "reservas_desayuno",
    "Reservas_Nahuelitos": "reservas_nahuelitos",
    "Cancelar_Reservas": "cancelar_reservas",
    "Servicios_Room": "servicios_room/:idPDV",
    "Login_Aux": "login_aux",
    "recaptchav3": "recaptchav3",
    "recaptchav2": "recaptchav2",
};
export const pushSettings = {
    appID: 'd53bf79b-79d6-4be0-8cc4-a9a3af5b97c7',
    baseUrl: 'https://api.appery.io/rest/push/reg',
    baseSendUrl: 'https://api.appery.io/rest/push/msg',
    initOptions: {}
};
export const projectInfo = {
    guid: "d53bf79b-79d6-4be0-8cc4-a9a3af5b97c7",
    name: "Llao Llao Resort",
    description: ""
};
export const pwaInfo = {
    name: 'Llao Llao Resort',
    shortName: 'Llao Llao Resort',
    description: '',
    icon: 'assets/images/Escudo512x512.png'
};
export const IGNORED_VALUE = Symbol.for("AIO_REST_IGNORED_VALUE");
export const apiHost = "https://api.appery.io";
export const defaultProxy = "1c608bf0-52cd-4334-8927-9766546482c7";